module.exports = __webpack_public_path__ + "static/lottery-button.5719876d.png";